export interface ProductRequestDetail_Interface {
    id:number,
    title:String,
    amount:number,
    price:number,
    
}

export function Empty_ProductRequestDetail_Interface():ProductRequestDetail_Interface{
    return{
      id:0,
      title:'',
      amount:0,
      price:0,
    }
  }